import React from "react";
import styled from "styled-components";
import Button from "components/common/Button";

const ModifyBlock = styled.div`
  // background: green;  
  display: flex;
  margin-top: 1rem;
  margin-bottom: 3rem;
  button + button {
    margin-left: 0.5rem;
  }
`;

const StyledButton = styled(Button)`
  height: 2.125rem;
  & + & {
    margin-left: 0.5rem;
  }
`;

const ModifyBox = ({ onModify, onCancel }) => {
  return (
    <div className="ModifyBox">
      <ModifyBlock>
        <StyledButton color={"pink"} onClick={onModify}>
          글수정
        </StyledButton>
        <StyledButton onClick={onCancel}>취소</StyledButton>
      </ModifyBlock>
    </div>
  );
};

export default ModifyBox;
